
import {
  Component, Prop, Watch, Ref, Vue,
} from 'vue-property-decorator'
import ViewModel from '@/models/ViewModel'
import CreativeImportModule from '@/models/CreativeImportModule'
import CompanyPicker from '@/components/CompanyPicker/CompanyPicker.vue'
import Widget from '@/components/Widget/Widget.vue'
import SelectOption from '@/models/interface/SelectOption'
import FormInput from '@/components/FormInput/FormInput.vue'
import FooterNav from '@/components/FooterNav/FooterNav.vue'
import SelectPicker from '@/components/SelectPicker/SelectPicker.vue'
import WebMessage from '@/models/WebMessage'

@Component({
  components: {
    Widget,
    CompanyPicker,
    FormInput,
    FooterNav,
    SelectPicker,
  },
})
export default class CreativeImportEdit extends ViewModel {
  @Ref() readonly validator: any

  public busy: boolean = true

  public loading: boolean = true

  public creativeImport: any = new CreativeImportModule()

  public mounted() {
    this.busy = false
    this.loading = false
  }

  public tagOptions: SelectOption[] = []

  public addTag(newTag: string) {
    let tags: any = newTag
      .split(/[\r\n,\s]+/)
      .map(tag => tag.trim())
      .filter(tag => tag.length > 0)

    this.creativeImport.iscis = [...new Set([...(this.creativeImport.iscis || []), ...tags])]
    tags = tags.map((tag: string) => new SelectOption(tag, tag))
    this.tagOptions = [...new Set([...this.tagOptions, ...tags])]
  }

  public async save() {
    this.loading = true
    this.creativeImport.save(this.creativeImport).then((response: any) => {
      if ([200, 201].includes(response.status)) {
        this.$router.push({ name: 'creative-import-home' })
      }
      this.loading = false
    })
  }

  public created() {
    // if (this.$route.params.id) {
    //   CreativeImportModule.find(this.$route.params.id).then((response: any) => {
    //     console.log({ created: response })
    //     this.creativeImport = response.data.result
    //     this.tagOptions = (this.creativeImport.iscis || []).map(
    //       (tag: string) => new SelectOption(tag, tag),
    //     )
    //     this.loading = false
    //   })
    // }
  }
}
